import React from "react"
import Icon from "../atoms/Icon"
import Link from "../atoms/Link"
import GalleryLink from "../atoms/GalleryLink"


// if the link is a itemGalleryLink we resolve that here ( Link can also handle it but why pass it on )

const ReadMore = ({ text = "Read more", left, link, isWhite = false, translations }) => {

  const className = "m-read-more" + (isWhite ? " m-read-more--white" : "")

  if( link.contentType == "itemGalleryLink" ) {

    return <GalleryLink link={ link } className={ className } translations={ translations }/>

  }

  return (
    <Link link={ link } className={ className }>
      { text + " " }
      <Icon
        iconName={ `icon-chevron-${ left ? "left" : "right" }` }
        className="m-read-more__icon a-icon a-icon--xs"
      />
    </Link>
  )

}

export default ReadMore
